"use client"

import { useCurrentWorkspaceAccess } from "@/features/auth/hooks/use-current-workspace-access"

/** Fallback when the active workspace timezone is not yet loaded. Mirrors the API default. */
export const DEFAULT_WORKSPACE_TIMEZONE = "Africa/Kigali"

/**
 * IANA timezone of the active workspace (from `/tenant/auth/me`). Finance date
 * boundaries (today / this week / month / quarter / year / custom) are computed
 * in this zone so list, overview and export agree regardless of the browser TZ.
 */
export function useActiveWorkspaceTimezone(): string {
  const access = useCurrentWorkspaceAccess()
  const timezone = access?.workspace?.timezone
  return timezone && timezone.trim().length > 0 ? timezone : DEFAULT_WORKSPACE_TIMEZONE
}
